import { useEffect, useState } from 'react'
import { apiRead, usePermissions } from '../admin/primitives.js'
import { compte, nuitLongue, type Resume } from './associations-model.js'

/**
 * ASSOCIATIONS — LE COMPTE RÉEL DE LA TUILE DU HUB EXPLOITATION (20/10/2026).
 *
 * Doctrine « tuile = navigation » (verrouillée par les tests du hub) : un
 * compte, une phrase, la flèche de la tuile — ni table, ni action, rien de
 * stocké. La tuile lit `/api/v1/associations/resume` à l'ouverture du hub ;
 * sans le droit de lecture, aucun appel ne part. Une lecture refusée ou en
 * panne se dit, sans chiffre inventé.
 */
export function SyntheseAssociations() {
  const { permissions, loading } = usePermissions()
  const peutLire = !loading && permissions.includes('association.read')
  const [r, setR] = useState<Resume | null>(null)
  const [erreur, setErreur] = useState(false)

  useEffect(() => {
    if (!peutLire) return
    let vivant = true
    void apiRead<Resume>('/api/v1/associations/resume')
      .then((x) => { if (!vivant) return; if (x.status === 200) setR(x.data); else setErreur(true) })
      .catch(() => { if (vivant) setErreur(true) })
    return () => { vivant = false }
  }, [peutLire])

  if (!peutLire) return null
  if (erreur) return <span className="fh-tile__synthese fh-tile__synthese--muette">Compte indisponible</span>
  if (!r) return <span className="fh-tile__synthese" aria-busy="true">…</span>
  return (
    <span className="fh-tile__synthese">
      <strong className="fh-tile__compte">{compte(r.actives, 'association', 'associations')}</strong>
      <span className="fh-tile__detail">
        {r.a_decider > 0 ? `${r.a_decider} à décider` : 'rien à décider'}
        {r.prochaine ? ` · prochaine : ${r.prochaine.name}, ${nuitLongue(r.prochaine.nuit)}` : ''}
      </span>
    </span>
  )
}
